<template>
    <div v-if="lang" class="agency-lead-form">
        <h4>
            {{ lang.title }}
        </h4>

        <form @submit.prevent="sendLead" @keydown="form.errors.clear($event.target.name)">
            <my-input
                v-model="form.first_name"
                name="first_name"
                :label="lang.labels.first_name"
            />

            <error-span :error="form.errors.get('first_name')"></error-span>

            <my-input
                v-model="form.last_name"
                name="last_name"
                :label="lang.labels.last_name"
            />

            <error-span :error="form.errors.get('last_name')"></error-span>

            <my-input
                v-model="form.email"
                name="email"
                type="email"
                :label="lang.labels.email"
            />
            
            <error-span :error="form.errors.get('email')"></error-span>


            <my-input
                v-model="form.phone"
                name='phone'
                type="phone"
                :label="lang.labels.phone"
            />

            <error-span :error="form.errors.get('phone')"></error-span>

            <my-textarea
                v-model="form.message"
                name="message"
                :label="lang.labels.message"
            />

            <error-span :error="form.errors.get('message')"></error-span>

            <div class="privacy-policy" v-html="lang.agreements.privacy"></div>

            <marketing-checkbox v-model="form.marketing" :lang="lang" />

            <button class="btn btn-network">
                {{ lang.labels.send }}
            </button>
        </form>
    </div>
</template>

<script>
import { Form } from '../../classes/Form'
import MarketingCheckbox from './MarketingCheckbox'

export default {
    components: {
        'marketing-checkbox': MarketingCheckbox,
    },

    props: {
        agencyId: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            form: new Form({
                agency_id: this.agencyId,
                email: '',
                first_name: '',
                last_name: '',
                marketing: false,
                message: '',
                phone: '',
                origin: window.location.href,
            }),

            rules: {
                email: ['required', 'email'],
                first_name: ['required'],
                last_name: ['required'],
                phone: ['required', 'numeric', 'min:9'],
            },
        }
    },

    computed: {
        lang() {
            return this.$root.lang.agency_lead_form
        },
    },

    methods: {
        sendLead() {
            if(! this.form.validate(this.rules)) {
                return false
            }

            this.form.post('/api/leads')
                .then(({data}) => {
                    flash(this.lang.flash.success)
                    this.$parent.close()
                })
        },
    },
}
</script>